import { createSlice } from '@reduxjs/toolkit';
import { ErrorActions } from 'common/constants/actions';

interface Feature {
  id: number;
  name: string;
  enabled: boolean;
}

interface FeatureState {
  features: Feature[];
  initialized: boolean;
}

const initialState = {
  features: [],
  initialized: false,
} satisfies FeatureState as FeatureState;

const featureSlice = createSlice({
  name: 'features',
  initialState,
  reducers: {
    setFeatures(state, action) {
      state.features = action.payload;
      state.initialized = true;
    },
    clearFeatures(state) {
      state.features = [];
      state.initialized = false;
    },
  },
  extraReducers: builder => {
    builder.addCase(ErrorActions.CLEAR_ALL, state => {
      state.features = [];
    });
  },
  selectors: {
    isInitialized: state => state.initialized,
    getFeatures: state => state.features,
    getFeatureById: (state, id: number) => state.features.find(feature => feature.id === id),
    isFeatureEnabled: (state, name: string) =>
      state.features.some(feature => feature.name === name && feature.enabled),
  },
});

export const { setFeatures, clearFeatures } = featureSlice.actions;
export default featureSlice;
